import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgHelp = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.75 9.745a1.25 1.25 0 1 1 1.708 1.163c-.518.204-1.208.732-1.208 1.592a.75.75 0 0 0 1.5.002.2.2 0 0 1 .034-.05.6.6 0 0 1 .224-.148 2.75 2.75 0 1 0-3.758-2.56.75.75 0 0 0 1.5 0"
        clipRule="evenodd"
      />
      <path fill="currentColor" d="M12 14.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 2C6.477 2 2 6.477 2 12c0 1.764.458 3.424 1.26 4.864l-.988 3.954a.75.75 0 0 0 .91.91l3.954-.989C8.576 21.542 10.236 22 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2M3.5 12a8.5 8.5 0 1 1 4.134 7.295.75.75 0 0 0-.568-.085l-3.035.76.759-3.036a.75.75 0 0 0-.085-.568A8.46 8.46 0 0 1 3.5 12"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgHelp;
